import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { RtUICommonModule } from '../common/common.module';
import { RtUIDialogModule } from '../dialog/dialog.module';
import { BulkSelectModule } from './bulk-select/bulk-select.module';
import { BulkSelectionMessagesComponent } from './bulk-selection-messages/bulk-selection-messages.component';
import { SelectableCardComponent } from './checkbox-card/selectable-card.component';
import { CheckboxComponent } from './checkbox/checkbox.component';
import { DatePickerComponent } from './date-picker/date-picker.component';
import { EmailsInputModule } from './emails-input/emails-input.module';
import { AttachmentItemModule } from './file-upload/attachment-item/attachment-item.module';
import { AttachmentPlaceloaderModule } from './file-upload/attachment-placeloader/attachment-placeloader.module';
import { AttachmentPreviewDialogModule } from './file-upload/attachment-preview-dialog/attachment-preview-dialog.module';
import { FileUploadModule } from './file-upload/file-upload/file-upload.module';
import { FormErrorDirective } from './form-error/form-error.directive';
import { FormFieldComponent } from './form-field/form-field.component';
import { InputComponent } from './input/input.component';
import { MaskedInputComponent } from './masked-input/masked-input.component';
import { RtPhoneInputComponent } from './phone-input/phone-input.component';
import {
  PROTECTED_CONTROLS_PROVIDERS,
  ProtectedControlDirective,
  ProtectedControlsContextDirective,
} from './protected-controls/public_api';
import { RadioFormGroupComponent } from './radio-form-group/radio-form-group.component';
import { RadioComponent } from './radio/radio.component';
import { RangeSelectionInputComponent } from './range-selection-input/range-selection-input.component';
import { SelectDropdownComponent } from './select/select-dropdown/select-dropdown.component';
import { SelectModule } from './select/select.module';
import { TaggerModule } from './tagger/tagger.module';
import { TextareaComponent } from './textarea/textarea.component';
import { TimePickerDropdownModule } from './time-picker/time-picker-dropdown/time-picker-dropdown.module';
import { TimePickerModule } from './time-picker/time-picker.module';
import { TimeZonePickerDropdownComponent } from './time-zone-picker/time-zone-picker-dropdown/time-zone-picker-dropdown.component';
import { TimeZonePickerModule } from './time-zone-picker/time-zone-picker.module';
import { TypeaheadModule } from './typeahead/typeahead.module';

const COMPONENT_MODULES = [
  BulkSelectModule,
  EmailsInputModule,
  TaggerModule,
  TypeaheadModule,
  AttachmentItemModule,
  AttachmentPreviewDialogModule,
  AttachmentPlaceloaderModule,
  FileUploadModule,
  SelectModule,
  TimePickerDropdownModule,
  TimePickerModule,
  TimeZonePickerModule,

  CheckboxComponent,
  SelectableCardComponent,
  InputComponent,
  BulkSelectionMessagesComponent,
  DatePickerComponent,
  FormFieldComponent,
  MaskedInputComponent,
  ProtectedControlDirective,
  ProtectedControlsContextDirective,
  RadioComponent,
  RadioFormGroupComponent,
  RangeSelectionInputComponent,
  SelectDropdownComponent,
  TextareaComponent,
  TimeZonePickerDropdownComponent,
  FormErrorDirective,
  RtPhoneInputComponent,
];

@NgModule({
  imports: [
    ReactiveFormsModule,
    FormsModule,
    RtUICommonModule,
    RtUIDialogModule,
    ...COMPONENT_MODULES,
  ],
  exports: [ReactiveFormsModule, FormsModule, ...COMPONENT_MODULES],
})
export class RtUIFormsModule {
  public static forRoot(): ModuleWithProviders<RtUIFormsModule> {
    return {
      ngModule: RtUIFormsModule,
      providers: [...PROTECTED_CONTROLS_PROVIDERS],
    };
  }
}
